import React, { ReactNode } from 'react';
import { Box } from '@televet/kibble-ui/build/chakra';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { Tooltip } from '@televet/kibble-ui/build/components/Tooltip';

type TooltipTextProps = {
  text: string;
  tooltipText?: string;
  children?: ReactNode;
};

const TooltipText = ({ text, tooltipText }: TooltipTextProps): JSX.Element => {
  return tooltipText ? (
    <Tooltip label={tooltipText}>
      <Box cursor="default">
        <Text size="sm">{text}</Text>
      </Box>
    </Tooltip>
  ) : (
    <Text size="sm">{text}</Text>
  );
};

export default TooltipText;
